import script from "./OnboardingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingModal.vue?vue&type=style&index=0&id=5b8a8358&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8a8358"]])

export default __exports__